@use "assets/styles/abstracts/variables" as v;
@use "assets/styles/abstracts/mixins/typography" as t;

.statusScreen {
    position: relative;
    z-index: 4;
    border-radius: 10px;
    max-width: 456px;
    border: 1px solid v.$palette-signal-live;
    box-shadow: v.$shadow-dropdown;
    background: v.$gradient-black;
    padding: 48px;
    margin: 0 auto;
}

.closeIconWrapper {
    position: absolute;
    top: 19px;
    right: 28px;
    cursor: pointer;
}

.title {
    color: v.$palette-white;
    @include t.text(24px, 32px, semi-bold);
    margin-bottom: 8px;
}

.description {
    color: v.$palette-signal-structure;
    @include t.text(16px, 24px, regular);
    margin-bottom: 24px;
    margin-bottom: 24px;
}

.link {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
    width: 100%;
    height: 48px;
    padding: 8px 24px;
    border-radius: 8px;
    background: v.$palette-green-500;
    color: v.$palette-white;
    cursor: pointer;
    @include t.text(16px, 26px, "semi-bold");
    text-align: center;
    text-decoration: none;
}